import { render, staticRenderFns } from "./HotelAdministration.vue?vue&type=template&id=38b8cf7d&scoped=true&"
import script from "./HotelAdministration.vue?vue&type=script&lang=ts&"
export * from "./HotelAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./HotelAdministration.vue?vue&type=style&index=0&id=38b8cf7d&prod&lang=scss&scoped=true&"
import style1 from "./HotelAdministration.vue?vue&type=style&index=1&id=38b8cf7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8cf7d",
  null
  
)

export default component.exports